import { Flash } from "../general";
import Modal from "./modal";

const AjaxListener = {

  init: function() {
    document.addEventListener("ajax:success", AjaxListener.ajaxSuccessHandler);
    document.addEventListener("ajax:error", AjaxListener.ajaxErrorHandler);
  },

  ajaxSuccessHandler: function(event, xhr, settings) {
    try {
      let json = event.detail[0];
      if (json.redirect_path) {
        if(json.msg) window.success = json;
        Turbolinks.visit(json.redirect_path);
      }
      else {
        if (json.msg) {
          if (json.modal) {
            Modal.showOkModal(json.modal_title || 'Úspěch', json.msg);
          } else {
            Flash.success(json.msg);
          }
        }
      }
      if (json.kind) {
        AjaxListener.router(json, json.kind)
      }
    }
    catch(e) {
      Modal.showErrorModal('Došlo k chybě', 'Nastala neočekávaná chyba.')
    }
  },

  ajaxErrorHandler: function(event, xhr, settings) {
    try {
      let json = event.detail[0];

      if (json.redirect_path) {
        if (json.msg) {
          window.error = json;
        }
        Turbolinks.visit(json.redirect_path);
      }
      else {
        if (json.msg) {
          if (json.modal) {
            Modal.showErrorModal(json.modal_title || 'Došlo k chybě', json.msg);
          } else {
            Flash.error(json.msg);
          }
        }
      }

    }
    catch(e) {
      Modal.showErrorModal('V aplikaci nastala neočekávaná chyba.',' Zkuste, prosím, svou akci znovu opakovat. V případě, že se chyba opakuje, kontaktujte nás.');
    }
  },

  // process general actions
  router: function(json) {
    switch(json.type) {
      case 'notice_accepted':
        let notice = $('[data-notice-id="' + json.notice_id + '"]');
        notice.addClass('hidden');
        break;
    }
  }

};

export default AjaxListener;
